import React from 'react';
import classNames, { Argument } from 'classnames';

// Languages whose ISO 639-1 code has no embedded country (e.g. `sv`, not `sv_se`) and whose
// spoken country isn't the code itself.
const isoMapping: Record<string, string> = {
  sv: 'se',
  uk: 'ua',
};

interface FlagProps {
  locale: string;
  className?: Argument;
}

const Flag: React.FC<FlagProps> = ({ locale, className }) => {
  const [language, country] = locale.split('_');
  const isoLocale = country ?? isoMapping[language] ?? language;

  return (
    <span
      data-testid={`selected-language-${locale}`}
      className={classNames(`fi fi-${isoLocale} bg-cover! rounded-full shadow-inner shrink-0 kiosk:size-16`, className)}
    />
  );
};

export default Flag;
